<div class="login_form" *ngIf="ShowLoginForm">

    <div class="logo"> <img src="../../../../../assets/images/logo/flowtrics_logo.png"  ></div>

    <div class="title" >CREATE AN ACCOUNT</div>

    <form [formGroup]="loginForm">
        <div class="divideCol">
            <div class="left blk">
                <mat-form-field appearance="fill">
                    <mat-label>First Name</mat-label>
                    <input matInput  formControlName="firstName" maxlength="50"
                    (keypress)="allowAlphabetOnly($event)" #firstname autocomplete="false" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>
                        {{ titleAlert }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="right blk">
                <mat-form-field appearance="fill">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="lastName" maxlength="50"
                    (keypress)="allowAlphabetOnly($event)" autocomplete="false" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>
                        {{ titleAlert }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>


        <div class="divideCol">
            <div class="left blk">
                <mat-form-field appearance="fill">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" maxlength="100"  autocomplete="false">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>

                    <mat-error>
                        {{ getErrorEmail() }}
                    </mat-error>
                   
                </mat-form-field>
            </div>
            <div class="right blk">
                <mat-form-field appearance="fill">                   
                    <mat-label>Phone</mat-label>
                    <span matPrefix>+1 &nbsp;</span>
                    <input matInput placeholder="Phone" formControlName="phoneNumber" 
                    (keypress)="allowOnlyNumber($event)" mask="(000) 000-0000" maxlength="10" required>
                    <mat-error>{{getPhoneErrorMessage()}}</mat-error>
                    <mat-icon matSuffix>local_phone</mat-icon>
                </mat-form-field>
            </div>
        </div>

        <div class="divideCol">
            <div class="left blk">
                <mat-form-field appearance="fill">
                    <mat-label>Password</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" formControlName="password"
                        placeholder="Enter your password"  autocomplete="off" required>
                    <mat-icon class="eye" matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-hint class="errorpass">Choose a password of at least eight characters with one uppercase
                        letter, one lowercase letter, one special character and one number
                    </mat-hint>
                    <mat-error class="errorpass">
                        {{ getErrorPassword() }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="right blk">
                <mat-form-field appearance="fill">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" placeholder="Confirm your password"
                        formControlName="confirmPassword" (keyup)="matchPassword()" autocomplete="off" required>
                    <span matSuffix class="eye" (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide">
                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </span>
                    <mat-error>
                        Password does not match
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <br>
        <br>
        <button mat-flat-button color="primary" class="submit-button" 
        [disabled]="loginForm.invalid || !loginForm.dirty" (click)="SaveUserReg(loginForm.value)">  SIGN UP </button>
        
    </form>    
</div>

<div class="login_form" *ngIf="ShowLoginFormforMessage">
    <div class="logo"> <img src="../../../../../assets/images/logo/flowtrics_logo.png"  ></div>
    <div class="title" >{{this.message}}</div>
    <div class="iconGreen">
        <mat-icon>how_to_reg</mat-icon>
    </div>
    <div class="textCenter">
        <button mat-flat-button color="primary" class="submit-button" [routerLink]="'/auth/login'">Login</button> 
    </div>
</div>

<div class="progress-loader" *ngIf="spinner">

    <div class="lds-ripple" ><div></div><div></div></div>
  </div>